@defer (when controlContainer && $addressLines()) {
  @let errorText = "field is required";
  <div class="w-full flex flex-col" data-testid="address-form-container">
    <ng-container formArrayName="addressLines" class="flex flex-col gap-4">
      @for (
        addressGroup of $addressLines().controls;
        track $index;
        let i = $index
      ) {
        <ng-container [formGroup]="addressGroup">
          @for (
            address of addressGroup.controls | keyvalue;
            track address.key;
            let index = $index
          ) {
            @let label = addressLineLabels()![index] | titlecase;
            <wcg-input-field
              [formControlName]="address.key"
              [label]="label"
              [errorText]="label + ' ' + errorText"
              [attr.data-testid]="'address-' + address.key + '-input'"
              class="my-4"
            />
          }
        </ng-container>
      }
    </ng-container>
    <div class="flex flex-col gap-4">
      <wcg-uni-select
        formControlName="countryId"
        label="Country"
        [required]="true"
        [errorText]="'Country' + ' ' + errorText"
        [options]="countries()"
        data-testid="address-country-select"
        class="w-1/2 my-4 address-form__display-error"
      />
      <div
        class="flex flex-row justify-between gap-4"
        data-testid="state-zip-container"
      >
        @let stateErrorText = stateLabel() + " " + errorText;
        @if (!$stateGroup().length) {
          <wcg-input-field
            class="w-1/2 my-4"
            formControlName="state"
            [label]="stateLabel()"
            [isRequired]="true"
            [errorText]="stateErrorText"
            data-testid="address-state-input"
          />
        } @else {
          <wcg-uni-select
            class="w-1/2 my-4 address-form__display-error"
            formControlName="state"
            [label]="stateLabel()"
            [required]="true"
            [errorText]="stateErrorText"
            [options]="$stateGroup()"
            data-testid="address-state-select"
          />
        }

        <wcg-input-field
          class="w-1/2 my-4"
          formControlName="zipCode"
          label="Zip Code"
          [isRequired]="true"
          [errorText]="'Zip Code' + ' ' + errorText"
          data-testid="address-zip-code-input"
        />
      </div>
    </div>
  </div>
}
